import { DayOfWeek, QueryFactory } from '@lmt/shared-types';

export function useFirstDayOfWeek(): DayOfWeek {
  const calendarSettingsQuery =
    QueryFactory.CalendarSettingsQuery.useGetQuery();
  return calendarSettingsQuery.data?.firstDayOfWeek ?? 1;
}
